export const payoutAccountKeys = {
  all: ['payoutAccounts'] as const,
  list: () => [...payoutAccountKeys.all, 'list'] as const,
  eventAccount: (eventId: number) => [...payoutAccountKeys.all, 'event', eventId] as const,
}
